module.exports = __webpack_public_path__ + "img/battery_on_2_inputs.f270c484.png";